import { createApi } from "@reduxjs/toolkit/query/react";
import { IApiResponse, IPaginate } from "../../../interfaces/common";
import { baseQuery } from "../common";
import { ILaboratoryTestV2 } from "../../../interfaces/labV2";

export const radRequestV2Api = createApi({
    reducerPath: "radRequestApi",
    baseQuery: baseQuery,
    tagTypes: ["RadRequestApi"],

    refetchOnReconnect: true,

    endpoints: (builder) => ({

        getRadRequestV2: builder.query<IApiResponse<IPaginate<ILaboratoryTestV2[]>>, { pagination: { page: number; limit: number }, tab?: string, startDueDate?: string, endDueDate?: string, startRequestDate?: string, endRequestDate?: string, status?: string, patientId?: string }>({
            query: ({ pagination: { page = 1, limit = 10 }, tab, startDueDate, endDueDate, startRequestDate, endRequestDate, status, patientId }) =>
                `/rad-request-v2?page=${page}&limit=${limit}${tab ? `&tab=${tab}` : ''}${startDueDate ? `&startDueDate=${startDueDate}` : ''}${endDueDate ? `&endDueDate=${endDueDate}` : ''}${startRequestDate ? `&startRequestDate=${startRequestDate}` : ''}${endRequestDate ? `&endRequestDate=${endRequestDate}` : ''}${status ? `&status=${status}` : ''}${patientId ? `&patientId=${patientId}` : ''}`,
            providesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        getRadRequestV2Appointment: builder.query<IApiResponse<IPaginate<ILaboratoryTestV2[]>>, { pagination: { page: number; limit: number }, startScanDate?: string, endScanDate?: string }>({
            query: ({ pagination: { page = 1, limit = 10 }, startScanDate, endScanDate }) =>
                `/rad-request-v2/appointment?page=${page}&limit=${limit}${startScanDate ? `&startScanDate=${startScanDate}` : ''}${endScanDate ? `&endScanDate=${endScanDate}` : ''}`,
            providesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        getRadRequestIdRecipients: builder.query<IApiResponse<ILaboratoryTestV2>, { id: string }>({
              query: ({ id }) => `/rad-request-v2/${id}/recipients`,
              providesTags: [{ type: "RadRequestApi", id: "LIST" }],
            }),
        createInternalRadRequestV2: builder.mutation<IApiResponse<ILaboratoryTestV2>, Partial<ILaboratoryTestV2>>({
            query: (body) => ({
                url: `/rad-request-v2/create-internal`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),

        createExternalRadRequestV2: builder.mutation<IApiResponse<ILaboratoryTestV2>, Partial<ILaboratoryTestV2>>({
            query: (body) => ({
                url: `/rad-request-v2/create-external`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        getRadRequestById: builder.query<IApiResponse<ILaboratoryTestV2>, { id: string }>({
            query: ({ id }) => `/rad-request-v2/${id}`,
            providesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        addSample: builder.mutation<IApiResponse<ILaboratoryTestV2>, { id: string; body: any }>({
            query: ({ id, body }) => ({
                url: `/rad-request-v2/${id}/add-sample`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        updateInternalRadRequest: builder.mutation<IApiResponse<ILaboratoryTestV2>, { id: string; body: any }>({
            query: ({ id, body }) => ({
                url: `/rad-request-v2/${id}/edit-internal`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        updateExternalRadRequest: builder.mutation<IApiResponse<ILaboratoryTestV2>, { id: string; body: any }>({
            query: ({ id, body }) => ({
                url: `/rad-request-v2/${id}/edit-external`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        cancelRadRequest: builder.mutation<IApiResponse<ILaboratoryTestV2>, { id: string; body: any }>({
            query: ({ id, body }) => ({
                url: `/rad-request-v2/${id}/cancel`,
                method: 'DELETE',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        addRadResult: builder.mutation<IApiResponse<ILaboratoryTestV2>, { id: string; body: any }>({
            query: ({ id, body }) => ({
                url: `/rad-request-v2/${id}/add-result`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        approveRadResult: builder.mutation<IApiResponse<ILaboratoryTestV2>, { id: string; body: any }>({
            query: ({ id, body }) => ({
                url: `/rad-request-v2/${id}/approve-result`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        declineRadResult: builder.mutation<IApiResponse<ILaboratoryTestV2>, { id: string; body: any }>({
            query: ({ id, body }) => ({
                url: `/rad-request-v2/${id}/decline-result`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        addDueDate: builder.mutation<IApiResponse<ILaboratoryTestV2>, { id: string; body: any }>({
            query: ({ id, body }) => ({
                url: `/rad-request-v2/${id}/add-due-date`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),
        addAppointment: builder.mutation<IApiResponse<ILaboratoryTestV2>, { id: string; body: any }>({
            query: ({ id, body }) => ({
                url: `/rad-request-v2/${id}/add-appointment`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),

        sendRadResult: builder.mutation<IApiResponse<ILaboratoryTestV2>, { data: FormData }>({
            query: ({ data }) => ({
                url: `/rad-request-v2/send-result`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: [{ type: "RadRequestApi", id: "LIST" }],
        }),


    }),
});

export const {
    useGetRadRequestV2Query,
    useGetRadRequestV2AppointmentQuery,
    useCreateInternalRadRequestV2Mutation,
    useCreateExternalRadRequestV2Mutation,
    useGetRadRequestByIdQuery,
    useGetRadRequestIdRecipientsQuery,
    useAddSampleMutation,
    useUpdateInternalRadRequestMutation,
    useUpdateExternalRadRequestMutation,
    useCancelRadRequestMutation,
    useAddRadResultMutation,
    useApproveRadResultMutation,
    useDeclineRadResultMutation,
    useAddDueDateMutation,
    useAddAppointmentMutation,
    useSendRadResultMutation,
} = radRequestV2Api;